export default __webpack_public_path__ + "static/media/bell.ca672212.wav";